import { combineEpics } from 'redux-observable';
import { getAfterLoginEpic } from './get-after-login';
import { getProductsEpic } from './get-products';
import { getProductsExtraFeaturesEpic } from './get-products-extra-feature';

const productsEpic = combineEpics(
  getProductsEpic,
  getAfterLoginEpic,
  getProductsExtraFeaturesEpic
);

export default productsEpic;
